module.exports = __webpack_public_path__ + "img/lichtgestalten1.2bc07039.png";